export const isMigratedSettingsEnabled = (country: string | undefined) => {
  return process.env.REACT_APP_SETTINGS_NEXTJS_MIGRATION_ENABLED === 'true';
};
